import script from "./txt-list.vue?vue&type=script&setup=true&lang=js"
export * from "./txt-list.vue?vue&type=script&setup=true&lang=js"

import "./txt-list.vue?vue&type=style&index=0&id=72035542&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72035542"]])

export default __exports__